<template>
  <div>
    <form v-if="!registrationComplete">
      <div class="d-flex w-100 justify-content-center">
        <img src="../img/security.svg" width="70%" class="mb-3 mx-auto" />
      </div>
      <h2>Enable Two-Factor Auth</h2>
      <vue-phone-number-input v-model="phone" @update="numberUpdated" />
      <div
        class="flex flex-column justify-content-start align-items-center mt-2"
      >
        <loading-button
          id="enableTwoFaButton"
          :disabled="!isPhoneValid"
          :loading="loading"
          @click="enableTwoFa"
        >
          Enable Two Factor Auth
        </loading-button>
      </div>
    </form>
    <div v-else class="flex flex-column justify-content-start">
      <b-tabs content-class="mt-3" justified>
        <b-tab title="Authy App" active>
          <h2>Download the Authy App</h2>
          <p>
            Download the Authy app on your iOS or Android device, and input your
            phone number to complete the process.
          </p>
          <loading-button
            class="mt-2"
            :loading="loading"
            @click="() => finishedSetup('ONETOUCH')"
          >
            I have done this
          </loading-button>
        </b-tab>
        <b-tab title="Generic Two FA">
          <div class="d-flex align-items-center flex-column">
            Please scan the QR code below with your two-factor authentication
            app of choice, and then click the button below.
            <br />
            <img :src="qrCodeUrl" />
            <loading-button
              :disabled="!isPhoneValid"
              class="mt-2"
              :loading="loading"
              @click="() => finishedSetup('OTP')"
            >
              Complete Setup
            </loading-button>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { LoadingButton } from '@inscribe/ui-kit';

export default {
  components: {
    'loading-button': LoadingButton,
  },
  data() {
    return {
      loading: false,
      intervalId: undefined,
      phone: '',
      phoneObject: {},
      registrationComplete: false,
      qrCodeUrl: undefined,
      otpCode: undefined,
    };
  },
  computed: {
    isPhoneValid() {
      return this.phoneObject.isValid;
    },
  },
  methods: {
    finishedSetup(type) {
      this.$router.push({
        name: 'await-2fa',
        query: {
          type,
          isEnabling: true,
          ...this.$route.query,
        },
      });
    },
    numberUpdated(phoneObject) {
      this.phoneObject = phoneObject;
    },
    enableTwoFa() {
      const data = new FormData();
      this.loading = true;

      data.append('phone_number', this.phoneObject.nationalNumber);
      data.append('country_code', this.phoneObject.countryCallingCode);
      this.$store
        .dispatch('registerTwoFa', data)
        .then((response) => {
          this.loading = false;
          this.registrationComplete = true;
          this.qrCodeUrl = response.data.qr_code;
        })
        .catch((error) => {
          this.loading = false;
          this.$notify({
            group: 'general',
            type: 'error',
            title: 'Error logging in',
            duration: 5000,
            text: error.response.data.message,
          });
        });
    },
  },
};
</script>
